<template>
    <div>
        <div class="com-page-title">
            <div class="inner">传灯祈福法会</div>
        </div>
        <div class="com-card">
            <div class="com-card-title">法会缘起</div>
            <div class="com-card-content">
                <div class="text-wrap com-text-justify">
                    <div v-html="$relaceToBr(payload.brief)" />
                </div>
            </div>
        </div>
        <div class="com-card">
            <div class="com-card-title">法会详情</div>
            <div class="com-card-content">
                <div class="com-form-wrap">
                    <van-form>
                        <van-field
                            class="field-yellow"
                            label="法会时间"
                            readonly
                            colon
                        >
                            <template #input>
                                {{ payload.date }}(农历)·18:45 - 20:45
                            </template>
                        </van-field>
                        <van-field
                            class="field-yellow"
                            label="法会地点"
                            readonly
                            colon
                        >
                            <template #input>
                                {{ payload.location }}
                            </template>
                        </van-field>
                        <van-field
                            class="field-yellow"
                            label="参与人员"
                            readonly
                            colon
                        >
                            <template #input>
                                {{ payload.participants }}
                            </template>
                        </van-field>
                    </van-form>
                </div>
            </div>
        </div>
        <div class="com-card">
            <div class="com-card-title">法会仪轨</div>
            <div class="com-card-content">
                <div class="text-wrap">
                    <p v-html="$relaceToBr(payload.sadhana)" />
                </div>
            </div>
        </div>
        <div class="com-card">
            <div class="com-card-title">参加须知（请仔细阅读）</div>
            <div class="com-card-content">
                <div class="text-wrap">
                    <p v-html="$relaceToBr(payload.participationNotice)" />
                </div>
                <br />
                <div class="com-form-submit">
                    <DefaultBtn @click="onRoute">报名登记</DefaultBtn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        nextPage: {
            type: Function
        },
        pageData: Object
    },
    data () {
        return {
            payload: this.pageData
        }
    },
    methods: {
        onRoute () {
            this.nextPage()
        }
    }
}
</script>

<style>

</style>